module.exports = __webpack_public_path__ + "media/markers/marker-cluster-teal-a1882410.svg";